import React, { useContext } from "react";
import { observer } from "mobx-react";

import classNames from "classnames";
import { BetDetailsModalStoreContext } from "@state/context/my-bets/BetDetailsModalStoreContext";
import { MyBetsBetContext } from "@state/context/my-bets/MyBetsBetContext";
import { CashoutStore } from "@state/stores/my-bets/CashoutStore";
import { BetDetailsModalStore } from "@state/stores/my-bets/BetDetailsModalStore";

export const BetDetailsAutoSellButton = observer(
	function BetDetailsAutoSellButton() {
		const bet = useContext(MyBetsBetContext);
		const store = useContext(BetDetailsModalStoreContext);

		let cashoutStore: CashoutStore;

		if (store instanceof BetDetailsModalStore) {
			cashoutStore = store.myBetsStore.cashoutStore;
		} else {
			cashoutStore = store.cashoutStore;
		}

		if (cashoutStore == null) {
			return null;
		}

		if (!WEBPACK_IS_AUTOCASHOUT_ENABLED) {
			return null;
		}

		const autoCashoutButtonClasses = classNames(
			"btn bet__btn__split__icon btn--med btn--ghost",
			{
				"bet__btn--autosell--set": bet.isAutoCashoutSet,
			}
		);

		const autoCashoutIconClasses = classNames("u-icon u-icon--sml", {
			"u-icon--settings u-color--core--snow": !bet.isAutoCashoutSet,
			"u-icon--set-stake u-color--core--snow": bet.isAutoCashoutSet,
		});

		if (
			WEBPACK_IS_AUTOCASHOUT_ENABLED &&
			bet.displayedAmount !== undefined &&
			bet.displayedAmount !== null &&
			bet.displayedAmount !== "0.00"
		) {
			return (
				<button
					className={autoCashoutButtonClasses}
					type="button"
					onClick={() => {
						cashoutStore.openAutosellBetDetails(bet);
						store.onAutoSellOpen();
					}}
				>
					<i className={autoCashoutIconClasses} />
				</button>
			);
		} else {
			return null;
		}
	}
);
